import { memo, useMemo } from 'react';

import { RegistrationStepProps } from './RegistrationStep.types';
import customStepComponents from './StepComponents';
import DefaultRegistrationStep from './StepComponents/DefaultRegistrationStep';
import { Box } from '@betty/moonlight';

function RegistrationStep({ step, ...props }: RegistrationStepProps) {
  const StepComponent = useMemo(
    () => customStepComponents[step.id] || DefaultRegistrationStep,
    [step.id],
  );
  return (
    <Box flex={1}>
      <StepComponent step={step} {...props} />
    </Box>
  );
}

export default memo(RegistrationStep);
